export const LANGS = ['pt', 'en'];
export const DEFAULT_LANG = 'pt';

export const ROUTES = {
  home: { pt: '', en: '' },
  media: { pt: 'media', en: 'media' },
  souvenir: { pt: 'souvenir', en: 'souvenir' },
  portfolio: { pt: 'portfolio', en: 'portfolio' },
  about: { pt: 'sobre-nos', en: 'about' },
  contact: { pt: 'contactos', en: 'contact' },
  privacy: { pt: 'privacidade', en: 'privacy' },
  cookies: { pt: 'cookies', en: 'cookies' },
  terms: { pt: 'termos', en: 'terms' },
};

export const pathFor = (key, lang) =>
  `/${lang}${ROUTES[key][lang] ? `/${ROUTES[key][lang]}` : ''}`;

export function routeKeyFromPath(lang, rest) {
  const clean = rest.replace(/^\/+|\/+$/g, '');
  for (const [key, map] of Object.entries(ROUTES)) {
    if (map[lang] === clean) return key;
  }
  return null;
}

export const BRAND_THEMES = {
  group: '#FFCE00',
  media: '#14DA64',
  souvenir: '#0CBEDD',
};

export const THEME_BY_ROUTE = {
  home: 'group',
  media: 'media',
  souvenir: 'souvenir',
  portfolio: 'group',
  about: 'group',
  contact: 'group',
  privacy: 'group',
  cookies: 'group',
  terms: 'group',
};
